/**
 * 采购商信息
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/28      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Lang from "@components/Lang/Lang";
import "./index.less";
class BuyerInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {model={}} = this.props;
        const {buyerVO = {}} = model;
        return (
            <Link to={`/customer/detail?id=${model.buyerId}`}
                  target="_blank"
                  className="buyer-info__wrap font_14 mt_12 color066">
                <div>
                    <div className="mb_4">
                    <span className="font_16 color089 font-weight-bold mr_8">
                        {buyerVO.code || '-'}
                    </span>
                        <span>{buyerVO.countryName || '-'}</span>
                    </div>
                    <div>
                    <span className="mr_32">
                        <span className="color089 mr_8">{Lang({id:'GongSiLeiXing',default:'公司类型'})}</span>
                        <span>{buyerVO.companyType || '-'}</span>
                    </span>
                        <span className="mr_32">
                        <span className="color089 mr_8">{Lang({id:'ZhuYingLeiMu',default:'主营类目'})}</span>
                        <span>{buyerVO.mainCategoryNames || '-'}</span>
                    </span>
                        <span className="mr_32">
                        <span className="color089 mr_8">{Lang({id:'XiaoShouQuDao',default:'销售渠道'})}</span>
                        <span>{buyerVO.sellChannelName || '-'}</span>
                    </span>
                        <span className="mr_32">
                        <span className="color089 mr_8">{Lang({id:'NianXiaoShouE',default:'年销售额'})}</span>
                        <span>{buyerVO.purchaseQuantityByYear || '-'}</span>
                    </span>
                    </div>
                </div>
                <i className="ri-arrow-right-s-line font_20 color089"></i>
            </Link>
        )
    }
}

BuyerInfo.defaultProps = {}

BuyerInfo.propTypes = {}

export default BuyerInfo;
